import React from "react";
import Lottie from "react-lottie";
import { defaultOption } from "../defaultOption";
import animationData from "../../../lottieData/Home/home-tab-visual_learning.json";

export default function HomeTabVLLottie({ isMobile }) {
  return (
    <Lottie
      options={defaultOption(animationData)}
      width={isMobile ? 250 : 400}
      isStopped={false}
      isPaused={false}
    />
  );
}

HomeTabVLLottie.defaultProps = {
  isMobile: false
};
